import Swiper from 'swiper';
import { Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/swiper-bundle.css';

// init text-media slider with swiper
const initTextMedia = () => {
  new Swiper(".ks-text-media .swiper-img-media", {
    modules: [Autoplay, EffectFade],
    speed: 1500,
    spaceBetween: 30,
    effect: "fade",
    loop: true,
    allowTouchMove: false,

    // autoplay settings
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
  });
};

export default initTextMedia;
